const productCategoryConfig = {
  PARAM_NAME: "categoryId",
};

export { productCategoryConfig };
